/**
 * The tags an hour carries as coloured dots (at most three, then +n); a
 * dashed dot when no tag holds but one cannot judge the hour.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import type { DropGenHourBucket } from '@trafficpulse/shared';

import { TagDot } from '../../../rules/tags';
import { hourTagsTitle, taggedNames, unknownNames } from './hour-tag-view';

interface Props {
  row: Pick<DropGenHourBucket, 'tags'>;
  colors?: Record<string, string>;
}

export const HourTagDots: FC<Props> = ({ row, colors }) => {
  const tagged = taggedNames(row);
  const unknown = tagged.length === 0 && unknownNames(row).length > 0;
  return (
    <span className="inline-flex items-center gap-0.5" title={hourTagsTitle(row)}>
      {tagged.slice(0, 3).map((name) => (
        <TagDot key={name} color={colors?.[name]} />
      ))}
      {tagged.length > 3 ? <span className="text-[10px] text-muted-foreground">+{tagged.length - 3}</span> : null}
      {unknown ? <TagDot unknown /> : null}
    </span>
  );
};
